import { render } from "./ctrl-bet-box-group-multi.vue?vue&type=template&id=f8f9203a&scoped=true&ts=true"
import script from "./ctrl-bet-box-group-multi.vue?vue&type=script&lang=ts"
export * from "./ctrl-bet-box-group-multi.vue?vue&type=script&lang=ts"

import "./ctrl-bet-box-group-multi.vue?vue&type=style&index=0&id=f8f9203a&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f9203a"]])

export default __exports__